import React, { Fragment, useState } from "react"
import { RestHelper } from '../../helper/restHelper'
import PopupOverlay from "../popup-overlay"

const NotaryAssign = (props) => {

    const api = RestHelper()

    var messageToSend = 'Are you sure you wish to assign the order to ' + props.notary_name + '?'
    var passedMessage = messageToSend
    var passedObject = props.notary_name

    const [showPopup, setShowPopUp] = useState(false)
    
    const openPopup = () => {
        setShowPopUp(true)
    }
    
    const clearModal = () => {
        setShowPopUp(false)
    }

    const assignNotary = () => {
        const options = {}
        const reqData = {'action' : 'assignNotary', 'newNotary' : props.notary, 'request_id': props.requestId }
        api
            .postCreate('/manage-appts-admin', options, reqData)
            .then(res => props.onClickResponse())
            .catch(err => console.log(err))
      }

return(
    <div>
        <button className="btn btn-sm btn-secondary mt-3 mb-2 rounded" onClick={() => {openPopup()}}>
            Assign
        </button>
    <Fragment>
        {showPopup && <PopupOverlay clearModal={clearModal} confirmAction={assignNotary} passedMessage={passedMessage} passedObject={passedObject} />}
    </Fragment>
    </div>
)
}
export default NotaryAssign;